// this is the vuex module for the Vision Performance Indicator
export const moduleVPI = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {},
  getters: {},
};
